import { getDefaultEndDate, getDefaultStartDate } from '@/lib/date-util';
import { getEnumKeyByEnumValue } from '@/lib/helper/event-flow-helper';
import EventFlowStep from './enums/event-flow/event-flow-step';
import EventType from './enums/EventType';
import { User } from './Profile';

export type EventResponse = {
    id: number;
    name: string;
    description: string;
    startDate: Date;
    type: EventType;
    projectName: string;
    role: string;
    selectedStartDate: Date;
    selectedEndDate: Date;
    step: EventFlowStep | keyof EventFlowStep | null;
    createdAt: Date | null;
    deletedAt: Date | null;
    createdBy: User;
};

export type InviteUserRequest = {
    eventId: number;
    userId: number;
};

export type RemoveUserRequest = InviteUserRequest;

export type EventRequest = {
    name: string;
    description: string;
    startDate: Date | null;
    type: EventType | null;
    selectedStartDate: Date;
    selectedEndDate: Date;
    step: EventFlowStep | null;
};

export type EventFlowSettings = {
    selectedStartDate: Date;
    selectedEndDate: Date;
    step: EventFlowStep | keyof EventFlowStep | null;
};

export type EventFlowSettingsResponse = EventFlowSettings & {
    startDate: Date;
};

export type EventFormData = {
    projectId: number | null;
    startDate: Date | null;
    name: string;
    description: string;
    type: EventType | null;
};

export type EventUpdateData = EventFormData & EventFlowSettings;

export type EventUpdate = {
    eventId: number | null;
    eventRequest: EventUpdateData;
};

export type EventFlowSettingsUpdate = {
    eventId: number;
    selectedDate: EventFlowSettings;
};

export function createEventRequestFromFormData(
    formData: EventFormData,
): EventRequest {
    const { name, startDate, description, type } = formData;

    return {
        name,
        startDate,
        description,
        type,
        selectedStartDate: getDefaultStartDate(startDate ?? new Date()),
        selectedEndDate: getDefaultEndDate(startDate ?? new Date()),
        step: getEnumKeyByEnumValue(
            EventFlowStep,
            EventFlowStep.THIRTY_MINUTES,
        ),
    };
}
